module.exports = __webpack_public_path__ + "static/media/nonotification.d3af7728.svg";